import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  companies: [],
  category: [],
  categoryById: {},
  company: false,
  loading: false,
  formLoading: false,
  error: false,
  success: false,
  ratings: false,
  categoryError: false,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Companies/index.js